export const NotificationBadge = ({ count }: { count: number }) => (
  <span
    style={{
      flexShrink: 0,
      minWidth: "20px",
      height: "20px",
      padding: "0 6px",
      borderRadius: "10px",
      backgroundColor: "#F24034",
      fontSize: "x-small",
      lineHeight: "20px",
      textAlign: "center",
      color: "white",
    }}
  >
    {count}
  </span>
);
